import { Eye, EyeOff } from 'lucide-react';
import { useState } from 'react';

/** PIN input: digits only, numeric keypad on phones, optional reveal. */
export function PinInput({
  id,
  value,
  onChange,
  autoComplete,
  placeholder,
  autoFocus,
  invalid,
}: {
  id: string;
  value: string;
  onChange: (v: string) => void;
  autoComplete: string;
  placeholder?: string;
  autoFocus?: boolean;
  invalid?: boolean;
}) {
  const [show, setShow] = useState(false);
  return (
    <div className="pin-wrap">
      <input
        id={id}
        className="input pin-input"
        type={show ? 'text' : 'password'}
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={12}
        autoComplete={autoComplete}
        placeholder={placeholder ?? '••••'}
        value={value}
        autoFocus={autoFocus}
        aria-invalid={invalid || undefined}
        onChange={(e) => onChange(e.target.value.replace(/\D/g, '').slice(0, 12))}
      />
      <button type="button" className="pin-reveal" onClick={() => setShow((s) => !s)} aria-label={show ? 'Hide PIN' : 'Show PIN'} aria-pressed={show}>
        {show ? <EyeOff size={16} /> : <Eye size={16} />}
      </button>
    </div>
  );
}
